import { api } from '@/trpc/client';

export const useCustomerApi = () => {
  const utils = api.useUtils();
  const getById = api.customer.getById.useQuery;
  const getDetailsById = api.customer.getDetailsById.useQuery;
  const all = api.customer.all.useQuery;
  const update = api.customer.update.useMutation({
    onSuccess: ({ id }) => {
      void utils.customer.all.invalidate();
      void utils.customer.getById.invalidate({ customerId: id });
      void utils.customer.getDetailsById.invalidate({ customerId: id });
    },
  });
  const create = api.customer.create.useMutation({
    onSuccess: () => {
      void utils.customer.all.invalidate();
    },
  });
  const deleteCustomer = api.customer.delete.useMutation({
    onSuccess: () => {
      void utils.customer.all.invalidate();
    },
  });

  return {
    getById,
    getDetailsById,
    create,
    all,
    update,
    deleteCustomer,
  };
};
